import { render, staticRenderFns } from "./daichaos.vue?vue&type=template&id=6b50444c&scoped=true&"
import script from "./daichaos.vue?vue&type=script&lang=js&"
export * from "./daichaos.vue?vue&type=script&lang=js&"
import style0 from "./daichaos.vue?vue&type=style&index=0&id=6b50444c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50444c",
  null
  
)

export default component.exports